import { render, staticRenderFns } from "./EmployabilityProductivityTab.vue?vue&type=template&id=46dfeda2&scoped=true&"
import script from "./EmployabilityProductivityTab.vue?vue&type=script&lang=js&"
export * from "./EmployabilityProductivityTab.vue?vue&type=script&lang=js&"
import style0 from "./EmployabilityProductivityTab.vue?vue&type=style&index=0&id=46dfeda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dfeda2",
  null
  
)

export default component.exports